import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  transform: "translate(0.5)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 20C3.5 17.2386 5.73858 15 8.5 15H16.5C19.2614 15 21.5 17.2386 21.5 20V21H3.5V20Z",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12.5",
  cy: "8",
  r: "4",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_5 = ["width", "height"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24",
  transform: "translate(0.5)"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12.5",
  cy: "8",
  r: "4.25",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.5 21V20C3.5 17.2386 5.73858 15 8.5 15H16.5C19.2614 15 21.5 17.2386 21.5 20V21",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'UserIcon',
  props: {
  width: {
    type: Number,
    default: 26
  },
  height: {
    type: Number,
    default: 26
  },
  wrapperClass: {
    type: String,
    default: ""
  },
  checked: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.checked)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_2,
        _createTextVNode(),
        _hoisted_3,
        _createTextVNode(),
        _hoisted_4
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("svg", {
        key: 1,
        width: __props.width,
        height: __props.height,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        class: _normalizeClass(__props.wrapperClass)
      }, [
        _hoisted_6,
        _createTextVNode(),
        _hoisted_7,
        _createTextVNode(),
        _hoisted_8
      ], 10, _hoisted_5))
}
}

})